import Fluxxor from 'fluxxor';
import Immutable from 'immutable';

import moment from 'ofs/moment';
import Constants from 'ofs/apps/core/constants';

import {user} from 'ofs/payload';
const USER = Immutable.fromJS(user);


const EnquiryStore = Fluxxor.createStore({
  initialize(options) {
    this.bindActions(
      Constants.CHANGE_CONTEXT_CITY, this.onCityChange,
      Constants.CHANGE_PAGE_DATE_RANGE, this.onDateRangeChange,
      'SEARCH_UPDATE_FILTERS_SUCCESS', this.onCurrencyChange
    );
    this.setMaxListeners(0);
    if (options.get('startDate')) {
      options = options.set('startDate', moment(options.get('startDate')).toDate());
    }
    if (options.get('endDate')) {
      options = options.set('endDate', moment(options.get('endDate')).toDate());
    }
    this.state = options;
  },

  onCityChange(payload) {
    this.state = this.state.set('cityCode', payload.cityCode);
    this.emit('change');
  },

  onDateRangeChange(payload) {
    this.state = this.state.set('startDate', payload.range.start.toDate()).set('endDate', payload.range.end.toDate());
    this.emit('change');
  },

  onCurrencyChange(payload) {
    const {filters, priceFilters} = payload;

    this.state = this.state
      .set('currency', filters.currency ? filters.currency['iso_4217'] : USER.getIn(['currency', 'iso_4217']))
      .set('budgetMax', filters['price_max']);
    this.emit('change');
  }

});

export default EnquiryStore;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/stores/enquiry.js
 **/